import React from 'react'
import { styled } from '@mui/material/styles'

const PREFIX = 'PageTitle'

const classes = {
  titleArea: `${PREFIX}-titleArea`
}

const Root = styled('div')(({ }) => ({
  [`&.${classes.titleArea}`]: {
    gridArea: 'title',
    alignItems: 'center',
    display: 'flex'
  }
}))

const PageTitle: React.FC<React.PropsWithChildren> = ({ children }) => {
  return (
    <Root className={classes.titleArea}>
      <section>
        <header>{children}</header>
      </section>
    </Root>
  )
}

export default PageTitle
